
import Vue from "vue";
import $ from "jquery";
import filters from "@/filters";
import Component from "vue-class-component";
import { AxiosResponse } from "axios";
import { Prop } from "vue-property-decorator";
import { Action, State, Mutation } from "vuex-class";
import { SchoolModel } from "@/models/academy.model";
import { CandidateVerify } from "@/models/candidate.types";
import { CandidateVerifyModel } from "@/models/candidate.model";
import { isUniversity } from "@/functions/userinterface.function";
import Badge from "@/components/properties/Badge.vue";
import PaginationMiniComponent from "@/components/paginations/PaginationMini.vue";
import ModalVerifyAcceptAll from "@/views/apps/candidate/ModalVerifyAcceptAll.vue";
import ModalVerifyAccept from "@/views/apps/candidate/ModalVerifyAccept.vue";
import ModalVerifyReject from "@/views/apps/candidate/ModalVerifyReject.vue";
import toast from "@/functions/toast.function";

@Component({
  components: {
    Badge,
    PaginationMiniComponent,
    ModalVerifyAcceptAll,
    ModalVerifyAccept,
    ModalVerifyReject,
  },
  filters,
})
export default class VerifyRequest extends Vue {
  /* VUEX */

  // ACTION
  @Action("actionSelectCandidateVerify", { namespace: "candidate" })
  private actionSelectCandidateVerify: any;
  @Action("actionPaginationCandidateVerify", { namespace: "candidate" })
  private actionPaginationCandidateVerify: any;
  @Action("actionResetCandidate", { namespace: "candidate" })
  private actionResetCandidate: any;
  @Action("actionIsAvailableToVerified", { namespace: "candidate" })
  private actionIsAvailableToVerified: any;

  // MUTATION
  @Mutation("mutationCandidateVerify", { namespace: "candidate" })
  private mutationCandidateVerify: any;

  // STATE
  @State("school", { namespace: "academy" })
  private school: SchoolModel;
  @State("array_verify", { namespace: "candidate" })
  private array_verify: any;
  @State("pagination_verify", { namespace: "candidate" })
  private pagination_verify: any;
  @State("candidate", { namespace: "candidate" })
  private candidate: any;
  @State("array_major", { namespace: "requirement" })
  private array_major: any;
  @State("locale")
  private locale: string;

  // MUTATION
  @Mutation("mutationArrayCandidateVerify", { namespace: "candidate" })
  private mutationArrayCandidateVerify: any;

  /* PROP */

  @Prop({ default: false }) private isDetail: boolean = false;

  /* INITIALIZATION */

  private showAcceptAllRequest = false;
  private showAcceptRequest = false;
  private showRejectRequest = false;
  private selectedCandidate: any = {};
  private onLoad: boolean = false;
  private activePage: number = 1;
  private isAvailableToVerified = false;

  private get wordingStudentID() {
    if (isUniversity(this.school.school_type)) {
      return this.$i18n.t("student_id_nisn_2");
    }

    return this.$i18n.t("student_id_nisn");
  }

  /* LIFECYCLE */

  private created() {
    this.actionIsAvailableToVerified({
      success: (res: AxiosResponse) => {
        this.isAvailableToVerified = res.data.data;
      }
    });
    this.actionResetCandidate();
    this.mutationArrayCandidateVerify(new Array<CandidateVerifyModel>());
    this.clickSearch();
    const self = this;
    $(document).ready(function () {
      $("#TableVerifyRequestCandidate").scroll(function () {
        if (
          ($(this).scrollTop() as number) + ($(this).innerHeight() as number) >=
          $(this)[0].scrollHeight
        ) {
          if (!self.onLoad) {
            if (self.array_verify.length == 0) {
              return;
            }
            if (self.onLoad) {
              return;
            }
            if (self.pagination_verify.url) {
              self.activePage++;
              setTimeout(() => {
                self.clickPage(self.activePage, self.pagination_verify.url);
              }, 200);
            }
          }
        }
      });
    });
  }

  /* METHOD */
  private approveAll() {
    if (this.isAvailableToVerified) this.showAcceptAllRequest = true;
    else toast.warning(this.$i18n.t("no_new_candidates_to_verify"));
  }
  private clickSearch() {
    this.actionSelectCandidateVerify();
  }

  /* LISTENER */

  private listenerAction() {
    this.clickSearch();
  }

  /* METHOD */

  private clickPage(page: number, url: string) {
    this.onLoad = true;
    this.actionPaginationCandidateVerify({
      url,
      page,
      callback: (response: AxiosResponse) => {
        this.onLoad = false;
      },
    });
  }

  private getLabel(major: any): string {
    if (this.locale === "id") {
      return major["translation"];
    }
    return major["label"];
  }

  private onConfirmed() {
    this.actionSelectCandidateVerify();
  }

  private clickDetailVerify(student: CandidateVerify) {
    this.mutationCandidateVerify(student);
    this.$router.push({
      name: "candidateVerify",
      params: { id: student.personal_info.id },
    });
  }
}
